export default __webpack_public_path__ + "static/media/doselect-logo-white.4d3014a6.svg";